// extracted by mini-css-extract-plugin
module.exports = {"app-footer":"bk_d6","appFooter":"bk_d6","logo":"bk_d3","sub-footer":"bk_d7","subFooter":"bk_d7","links":"bk_d8","copy":"bk_d9"};